import { render, staticRenderFns } from "./ConfigAlertZabbix.vue?vue&type=template&id=694ff3ac&"
import script from "./ConfigAlertZabbix.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertZabbix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports